// src/components/companies/companiesList/newCompaniesList/companiesTable/shared/headingSortMenu/index.jsx

import { Box, Icon, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import ArrowDownSvg from "@/assets/svg/arrow-down-16x16.svg";
import SortedUp from "@/assets/svg/companiesList/sorted-up.svg";
import HideIconSvg from "@/assets/svg/hide-icon.svg";
import { useActions } from "@/hooks/useActions";
import useCompaniesListRequest from "@/hooks/useCompaniesListRequest";
import newViewSelectors from "@/store/newView/newView.selectors";

import SortItem from "./SortItem";


const menu = [
  { id: 1, title: "Sort A→Z", icon: SortedUp, key: "asc" },
  { id: 2, title: "Sort Z→A", icon: SortedUp, key: "desc" },
  { id: 3, title: "Hide this field", icon: HideIconSvg, key: null },
];

const HeadingSortMenu = ({ heading }) => {
  const { setViewParams, setToggleColumnsField } = useActions();
  const { getCompanies } = useCompaniesListRequest();
  const currentView = useSelector(newViewSelectors.getCurrentView());
  const currentParams = useSelector(newViewSelectors.getViewParams());
  const viewColumns = currentParams?.[currentView?.id]?.columns;

  const onSortHandler = (data) => {
    const options = {
      orderBy: heading?.orderBy,
      direction: data?.key?.toUpperCase(),
      limit: 25,
      page: 1,
    };
    getCompanies({ params: options });
    setViewParams({
      key: currentView?.id,
      params: {
        orderBy: {
          label: heading?.title,
          value: heading?.orderBy,
          id: heading?.id,
        },
        direction: data?.direction?.value?.toUpperCase(),
      },
    });
  };

  const onToggleColumns = () => {
    const columns = viewColumns?.includes(heading?.id)
      ? viewColumns?.filter((clmn) => clmn !== heading?.id)
      : [...viewColumns, heading?.id];
    setToggleColumnsField(heading?.id);
    setViewParams({
      key: currentView?.id,
      params: {
        columns,
      },
    });
  };

  return (
    <Menu>
      {({ isOpen }) => (
        <>
          <MenuButton justifySelf={"end"}>
            <Icon
              as={ArrowDownSvg}
              transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
              transition={"all 0.4s ease-in-out"}
            />
          </MenuButton>
          <MenuList
            minW={"220px"}
            color={"mainBlue"}
            fontSize={"14px"}
            fontWeight={"400"}
            lineHeight={"1.35"}
            letterSpacing={"0.28px"}
            zIndex={"30"}
          >
            {heading?.isSort ? (
              <>
                {menu?.slice(0, 2)?.map((item) => (
                  <SortItem
                    key={item?.id}
                    item={item}
                    handler={onSortHandler}
                  />
                ))}
              </>
            ) : null}

            {heading?.isShow ? (
              <>
                {heading?.isSort ? (
                  <Box
                    borderBottomWidth={"1px"}
                    borderColor={"lightGray"}
                    mx={"12px"}
                  />
                ) : null}
                {menu?.slice(2)?.map((item) => (
                  <SortItem
                    key={item?.id}
                    item={item}
                    handler={onToggleColumns}
                  />
                ))}
              </>
            ) : null}
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default HeadingSortMenu;
